import { render } from "./AccessibilityButton.vue?vue&type=template&id=26b1644c"
import script from "./AccessibilityButton.vue?vue&type=script&lang=js"
export * from "./AccessibilityButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__